import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { getUserInfo } from 'app/core/auth/auth.reducer';
import { SharedModule } from 'app/shared';
import { Resource } from 'app/shared/acl/acl.model';
import { map } from 'rxjs';
import { requestRecurrenceMonths, requestSendEmails } from './notifications.actions';


@Component({
    selector: 'notifications-preferences',
    imports: [
        FormsModule,
        SharedModule,
    ],
    styles: [
        `
        .toggle {
            width: 6em;
        }
        `
    ],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="card-title d-flex justify-content-between">
                    <div class="h4">E-mail</div>
                    <div class="toggle">
                        <ui-toggle
                            [ngModel]="sendEmails()"
                            [preventDefault]="true"
                            (ngModelChange)="onSendEmailsChange(!$event)">
                        </ui-toggle>
                        {{ sendEmails() ? 'ON' : 'OFF' }}
                    </div>
                </div>
                <div>
                    Get a roll up of changes for saved properties in your inbox:
                    <ul class="mt-1">
                        <li *apAcl="[r.NOTIF_FOLDER_BL, r.NOTIF_AREA_BL]">Broker Listings 1x per day</li>
                        <li *apAcl="[r.NOTIF_FOLDER_PI, r.NOTIF_AREA_PI]">Other Changes 1x per week</li>
                        <li *apAcl="r.NOTIF_AREA_MLS">MLS Residential 1x per day</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="card mt-2">
            <div class="card-body">
                <div class="card-title">
                    <div class="h4">Notification Expiration</div>
                </div>
                <div class="form-group">
                    <label for="months">Months (12 months maximum)</label>
                    <div style="width: 6em">
                        <input-stepper
                            id="months"
                            [ngModel]="recurrenceMonths()"
                            (ngModelChange)="onRecurrenceMonthsChange($event)"
                            #monthsInput="ngModel"
                            [min]="1"
                            [max]="12"
                            [step]="1">
                        </input-stepper>
                    </div>
                    @if (monthsInput.errors?.min) {
                        <small class="d-block invalid-feedback">Number of months must be at least 1.</small>
                    }
                    @if (monthsInput.errors?.max) {
                        <small class="d-block invalid-feedback">Number of months cannot exceed 12.</small>
                    }
                </div>
                <ui-alert type="info">
                    <div class="d-flex align-items-start">
                        <div class="mr-1">
                            <i class="fa fa-info-circle"></i>
                        </div>
                        <div>
                            <p>Applicable to all New Notifications only.</p>
                            <p class="mb-0">
                                To renew or turn off an existing Notification, go to the Notification itself
                                and click Renew or select the Notifications Toggle to Off.
                            </p>
                        </div>
                    </div>
                </ui-alert>
            </div>
        </div>
    `,
})
export class NotificationsPreferencesComponent {

    r = Resource;

    private store = inject(Store);

    sendEmails = toSignal(this.store.select(getUserInfo).pipe(map(user => user.sendNotificationsEmail)), { initialValue: true });

    recurrenceMonths = toSignal(this.store.select(getUserInfo).pipe(map(user => user.notificationsRecurrence)), { initialValue: 12 });

    onSendEmailsChange(enabled: boolean) {
        this.store.dispatch(requestSendEmails({ enabled }));
    }

    onRecurrenceMonthsChange(months: number) {
        if (months >= 1 && months <= 12) {
            this.store.dispatch(requestRecurrenceMonths({ months }));
        }
    }
}
